import { Carousel, CarouselIndicators, CarouselItem, Modal, ModalBody } from "reactstrap";
import React, { useState } from "react";

export const CarouselJedai = ({ items }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const goToIndex = newIndex => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    const slides = (items || []).map((item, index) => {
        return (
            <CarouselItem onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)} key={item.src}>
                <img src={item.src} alt={item.altText} />

                <div className={"carousel-caption"}>
                    <div className={"container-fluid text-primary ml-md-6vw"}>
                        <div className={"row"}>
                            <div className={"col-md-3 text-left"}>
                                <h2>{item.title}</h2>
                                <div>{item.content}</div>
                                <RenderBtn item={item} />
                            </div>
                        </div>
                    </div>
                </div>
            </CarouselItem>
        );
    });

    return (
        <Carousel interval={18000} activeIndex={activeIndex} next={next} previous={previous}>
            <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
            {slides}
            {/* <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous}/>
            <CarouselControl direction="next" directionText="Next" onClickHandler={next}/>*/}
        </Carousel>
    );
};

const RenderBtn = ({ item }) => {
    if (!item.btnTitle) return null;

    if (item.btnType === "video" || item.btnType === "1" || item.btnType === 1) {
        return <VideoModal item={item} />;
    } else {
        return (
            <a href={item.btnLink} target="_blank" className={"btn btn-outline-primary mt-3"} rel="noreferrer">
                {item.btnTitle}
            </a>
        );
    }
};

const VideoModal = ({ item }) => {
    const [open, setOpen] = useState(false);

    const toggle = () => {
        setOpen(!open);
    };

    return (
        <>
            <a href="#" className={"btn btn-outline-primary mt-3"} onClick={toggle}>
                {item.btnTitle}
            </a>
            <Modal
                isOpen={open}
                toggle={toggle}
                className={"home-slider"}
                size={"xl"}
                backdropClassName={"backdrop-primary"}
            >
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={toggle}>
                    x
                </button>
                <ModalBody className="p-0">
                    <div className="popup-video">
                        <div className="embed-responsive embed-responsive-16by9">
                            <iframe src={item.btnLink} />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};
